import { SectionNav } from '@parsina/framework';
import { C } from '@parsina/framework/tokens';

/**
 * The sticky section strip for a record or a multi-view screen.
 *
 * Deliberately `SectionNav` and not `SegmentedControl`. A segmented control is
 * an `inline-flex` group with no overflow strategy: three or four Persian
 * labels overflow it at 320px and the PAGE starts scrolling sideways, which is
 * the one layout failure this design does not tolerate. `SectionNav` is a
 * thumb-scrollable strip that centres the active tab, and a strip scrolling is
 * not the page scrolling.
 *
 * Two screens currently wrap a `SegmentedControl` in an `overflow-x: auto` div
 * to get this behaviour, with a comment saying `SectionNav` is the right
 * control but is not in the pinned kit. It is: the pin is v0.10.1, and the
 * comment predates it. Those wrappers should be replaced by this component.
 *
 * The caller owns the matching `role="tabpanel"` and the URL state; this is
 * chrome, not routing.
 */
export default function MobileSectionNav({ items, active, onSelect, ariaLabel, sticky = true, style }) {
  return (
    <div
      style={{
        ...(sticky ? { position: 'sticky', top: 0, zIndex: 2 } : null),
        background: C.bg,
        borderBottom: `1px solid ${C.border}`,
        ...style,
      }}
    >
      <SectionNav items={items} active={active} onSelect={onSelect} ariaLabel={ariaLabel} />
    </div>
  );
}
